





import Vue from 'vue';
import axios from 'axios';
import api from '../api';
import OperationManager from '../components/OperationManager.vue';
export default Vue.extend({
  name: 'operation',
  data() {
    return {};
  },
  components: {
    OperationManager
  }
});
